import classNames from "classnames";

import { Icon, IconNameEnum, IconTypeEnum } from "../Icon";

import styles from "./Banner.module.scss";

export enum BannerVariant {
  Primary = "primary",
  Warning = "warning",
}

interface BannerProps {
  variant?: BannerVariant;
  iconName?: IconNameEnum;
  iconType?: IconTypeEnum;
  message: string;
}

export const Banner: React.FC<BannerProps> = ({
  variant = BannerVariant.Primary,
  iconName = IconNameEnum.info,
  iconType = IconTypeEnum.white,
  message,
}) => {
  return (
    <div className={classNames(styles.banner, styles[variant])}>
      <Icon name={iconName} type={iconType} />
      <p className={styles.message}>{message}</p>
    </div>
  );
};
